import {
  NaturalWrittenAdditionTwoByTwoTask,
  NaturalWrittenAdditionThreeByTwoTask,
  NaturalWrittenAdditionThreeByThreeTask,
  NaturalWrittenAdditionFourByFourTask,
  NaturalWrittenAdditionFiveByThreeTask,
} from "./podtemat1_dodawanie_pisemne_types/NaturalWrittenAdditionTask";

export const registry = {
  NaturalWrittenAdditionTwoByTwoTask,
  NaturalWrittenAdditionThreeByTwoTask,
  NaturalWrittenAdditionThreeByThreeTask,
  NaturalWrittenAdditionFourByFourTask,
  NaturalWrittenAdditionLargeMixedTask: NaturalWrittenAdditionFiveByThreeTask,
};

export function generateTasks() {
  return [
    NaturalWrittenAdditionTwoByTwoTask.generateTask(),
    NaturalWrittenAdditionThreeByTwoTask.generateTask(),
    NaturalWrittenAdditionThreeByThreeTask.generateTask(),
    NaturalWrittenAdditionFourByFourTask.generateTask(),
    NaturalWrittenAdditionFiveByThreeTask.generateTask(),
  ];
}

export function renderTask(task) {
  return registry[task.type]?.renderTask(task) || null;
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return registry[task.type]?.renderInput(task, userAnswer, onChange, disabled) || null;
}

export function checkAnswer(task, userAnswer) {
  return registry[task.type]?.checkAnswer(task, userAnswer) || false;
}

export function renderAnswer(task) {
  return registry[task.type]?.renderAnswer(task) || null;
}

export function renderExplanation(task) {
  return registry[task.type]?.renderExplanation(task) || null;
}

export function renderUserAnswer(task, userAnswer) {
  return registry[task.type]?.renderUserAnswer(userAnswer) || null;
}
